/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { inject } from '@angular/core';
import { combineLatest } from 'rxjs';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { AuthService } from '../auth.service';
import { AccountCreationStore } from 'src/app/common/auth/services/account-creation-store.service';

/**
 * This Function Guard is used to redirect the user to the login page if the user is a SSO user,
 * or the email is not set.
 */

export const canActivateLogin2: CanActivateFn = (route) => {
	const authService = inject(AuthService);
	const accountCreationStore = inject(AccountCreationStore);

	const isSsoUser$ = accountCreationStore.isSSO$;

	return combineLatest([accountCreationStore.email$, isSsoUser$]).pipe(
		take(1),
		map(([email, isSsoUser]) => {
			if (!email || isSsoUser) {
				return createUrlTreeFromSnapshot(route, ['../login'], route.queryParams);
			}
			return true;
		})
	);
};
